import React from 'react';
import { SvgIcon } from '@mui/material';

const Layers = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M21,8.92v.16a.49.49,0,0,1-.22.41l-7.67,5.25a1.49,1.49,0,0,1-.84.26h-.54a1.49,1.49,0,0,1-.84-.26L3.22,9.49A.49.49,0,0,1,3,9.08V8.92a.49.49,0,0,1,.22-.41l7.67-5.25A1.49,1.49,0,0,1,11.73,3h.54a1.49,1.49,0,0,1,.84.26l7.67,5.25A.49.49,0,0,1,21,8.92Zm-2.33,4.14L16.9,14.27,18,15l-5.85,4h-.22L6,15l1.06-.73L5.33,13.06,3.22,14.51a.49.49,0,0,0-.22.41v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l7.67-5.25a.49.49,0,0,0,.22-.41v-.16a.49.49,0,0,0-.22-.41Z" />
        </SvgIcon>
    );
};

export default Layers;
